/**
 * defa.views.RecipientGroupSnippet
 * A snippet view for RecipientGroups.
 * @version 1.0.0
 */


import Snippet from '../../poppet/snippet';

export const RecipientGroupSnippet = Snippet.extend( {
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	templateContext() {
		let superContext = Snippet.prototype.templateContext.call(this);
		return _.extend(superContext, {
			iconClass : 'icon icon-material icon-labelled icon-private',
			hasDelete: true,
			header    : this.model.get('name'),
		});
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	/**
	 * Triggers when a user clicks the delete button.
	 * The ui element for this button is inherited from poppet snippet.
	 * @void
	 */
	onClickDelete: function(event){
		event.preventDefault();
		this.trigger('delete:recipient:group', this);
	}
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );
export default RecipientGroupSnippet;